<script setup lang="ts">
import IconButton from "~/components/IconButton.vue";
import UpdateSearchModal from "~/features/searches/UpdateSearchModal.vue";
import { useSearchStore } from "~/store/searches";
import type { Search } from "~/common/types/types";
const store = useSearchStore();
const isModalOpen = ref(false);

const props = defineProps({
  search: {
    type: Object as PropType<Search>,
      required: true,
    },  
  });
const searchToUpdate = ref(props.search);

async function submitted(search: Search) {
  await store.updateSearch(search);
  isModalOpen.value = false;
}

</script>

<template>
    <div>
        <IconButton @click="isModalOpen = true">Update Search</IconButton>
        <UpdateSearchModal
            v-if="isModalOpen"
            v-model="searchToUpdate"
            @close="isModalOpen = false"
            @submitted="submitted"
        />
    </div>
</template>